import { defineMessages, type IntlShape } from 'react-intl'

import { parseOutcomeResponseDate } from './outcomeDate'

type AssessmentAttempt = {
  hasDuplicateAttempts: boolean
  lastTakenDate?: string
  measureDisplayName: string
}

const MESSAGES = defineMessages({
  assessmentAttemptAccessibilityLabel: {
    defaultMessage: '{assessment}, submitted {date}',
    description: 'Assessment name and submission time used to distinguish repeated same-day results',
  },
})

export const getAssessmentSubmissionDateTime = (lastTakenDate: string | undefined, intl: IntlShape) => {
  const responseDate = parseOutcomeResponseDate(lastTakenDate)
  if (!responseDate) return undefined

  return intl.formatDate(responseDate, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

export const getAssessmentAccessibilityLabel = (
  { hasDuplicateAttempts, lastTakenDate, measureDisplayName }: AssessmentAttempt,
  intl: IntlShape,
) => {
  if (!hasDuplicateAttempts) return measureDisplayName

  const submittedAt = getAssessmentSubmissionDateTime(lastTakenDate, intl)
  return submittedAt
    ? intl.formatMessage(MESSAGES.assessmentAttemptAccessibilityLabel, {
        assessment: measureDisplayName,
        date: submittedAt,
      })
    : measureDisplayName
}
